import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import '../../sass/components/flexibleModules/_components.RelatedResourcesSection.scss';

const RelatedResourcesSection = ({ data }) => {
    return (
        <div className="cp-flexibleRelatedResourcesSection l--genericpadding l--sectionPadding" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleRelatedResourcesSection__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.relatedResourcesSubTitle &&
                    <h3>{data.relatedResourcesSubTitle}</h3>
                }
                {data.relatedResourcesTitle &&
                    <h2>{data.relatedResourcesTitle}</h2>
                }
                <div className="cp-flexibleFullWidthGenericSection__grid l--flex">
                    {data.relatedResourcesRelationslPull &&
                        <>
                            {data.relatedResourcesRelationslPull.map((resourceItem, index) => (
                                <React.Fragment key={index}>
                                    {resourceItem.nodeType === 'Post' ?
                                        <Link className="cp-relatedResource" to={`/blog/${resourceItem.slug}`} key={index}>
                                            {resourceItem.featuredImage &&
                                                <GatsbyImage image={getImage(resourceItem.featuredImage.node.gatsbyImage)} alt={resourceItem.featuredImage.node.altText} />
                                            }
                                            <span className="cp-relatedResource__content">
                                                <h3>{resourceItem.nodeType}</h3>
                                                <h5>{resourceItem.title}</h5>
                                                {resourceItem.excerpt &&
                                                    <p dangerouslySetInnerHTML={{ __html: resourceItem.excerpt }} />
                                                }
                                            </span>
                                        </Link>
                                        :
                                        resourceItem.nodeType === 'Usecase' ?
                                            <Link className="cp-relatedResource" to={`/use-cases/${resourceItem.slug}`} key={index}>
                                                {resourceItem.featuredImage &&
                                                    <GatsbyImage image={getImage(resourceItem.featuredImage.node.gatsbyImage)} alt={resourceItem.featuredImage.node.altText} />
                                                }
                                                <span className="cp-relatedResource__content">
                                                    <h3>Use Case</h3>
                                                    <h5>{resourceItem.title}</h5>
                                                    {resourceItem.excerpt &&
                                                        <p dangerouslySetInnerHTML={{ __html: resourceItem.excerpt }} />
                                                    }
                                                </span>
                                            </Link>
                                            :
                                            resourceItem.nodeType === 'Customerstory' ?
                                                <Link className="cp-relatedResource" to={`/customer-stories/${resourceItem.slug}`} key={index}>
                                                    {resourceItem.featuredImage &&
                                                        <GatsbyImage image={getImage(resourceItem.featuredImage.node.gatsbyImage)} alt={resourceItem.featuredImage.node.altText} />
                                                    }
                                                    <span className="cp-relatedResource__content">
                                                        <h3>{resourceItem.nodeType}</h3>
                                                        <h5>{resourceItem.title}</h5>
                                                        {resourceItem.excerpt &&
                                                            <p dangerouslySetInnerHTML={{ __html: resourceItem.excerpt }} />
                                                        }
                                                    </span>
                                                </Link>
                                                :
                                                resourceItem.nodeType === 'News' ?
                                                    <Link className="cp-relatedResource" to={`/pressrelease/${resourceItem.slug}`} key={index}>
                                                        {resourceItem.featuredImage &&
                                                            <GatsbyImage image={getImage(resourceItem.featuredImage.node.gatsbyImage)} alt={resourceItem.featuredImage.node.altText} />
                                                        }
                                                        <span className="cp-relatedResource__content">
                                                            <h3>{resourceItem.nodeType}</h3>
                                                            <h5>{resourceItem.title}</h5>
                                                            {resourceItem.excerpt &&
                                                                <p dangerouslySetInnerHTML={{ __html: resourceItem.excerpt }} />
                                                            }
                                                        </span>
                                                    </Link>
                                                    :
                                                    resourceItem.nodeType === 'Resource' ?
                                                        <Link className="cp-relatedResource" to={`/resources/${resourceItem.whitePapersAndEbooks.resourceType === 'ebook' ? 'ebook' : resourceItem.whitePapersAndEbooks.resourceType === 'whitepaper' ? 'white-papers' : resourceItem.whitePapersAndEbooks.resourceType === 'analystreport' ? 'analyst-reports' : resourceItem.whitePapersAndEbooks.resourceType === 'infographics' ? 'guide' : resourceItem.whitePapersAndEbooks.resourceType === 'finance-how-to' ? 'finance-how-to' : ""}/${resourceItem.slug}`} key={index} data={resourceItem.whitePapersAndEbooks.resourceType}>
                                                            {resourceItem.featuredImage &&
                                                                <GatsbyImage image={getImage(resourceItem.featuredImage.node.gatsbyImage)} alt={resourceItem.featuredImage.node.altText} />
                                                            }
                                                            <span className="cp-relatedResource__content">
                                                                <h3>{resourceItem.nodeType}</h3>
                                                                <h5>{resourceItem.title}</h5>
                                                                {resourceItem.excerpt &&
                                                                    <p dangerouslySetInnerHTML={{ __html: resourceItem.excerpt }} />
                                                                }
                                                            </span>
                                                        </Link>
                                                        :
                                                        ""
                                    }
                                </React.Fragment>
                            ))}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default RelatedResourcesSection;